import React, { useContext } from 'react';
import LoginContext from './LoginContext';
import LoginComponent from './LoginComponent';
import NeedResetPassword from '../Password/NeedResetPassword';
import { navigateWithAuthenticatedRedirectUrl } from '../../Services/NavigationService/NavigationService';

type LoginRequiredProps = {
	children?: React.ReactNode;
};

const LoginRequired: React.FC<LoginRequiredProps> = ({ children }: LoginRequiredProps) => {
	const { isLoggedIn, performLogin, error, passwordResetData, supportUrl } =
		useContext(LoginContext);

	const params = new URLSearchParams(window.location.search);
	const redirectDestination = params.get('redirectDestination') ?? undefined;
	if (isLoggedIn) {
		// Redirect on old BO with uibootstrap/secureToken/redirect process
		// Allows to create a session on PHP side if needed
		if (redirectDestination) {
			navigateWithAuthenticatedRedirectUrl(redirectDestination);
		}
		if (passwordResetData?.needsPasswordReset) {
			return <NeedResetPassword passwordResetData={passwordResetData} />;
		}
		return children as React.ReactElement;
	}
	return (
		<LoginComponent
			performLogin={performLogin}
			errorMessage={error}
			supportUrl={supportUrl}
			redirectDestination={redirectDestination}
		/>
	);
};

export default LoginRequired;
